'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dAccounts$002dPage$0024 from "./presto.-List-Accounts-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002471 from "./presto.-Presto-Router$$anon$71.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$70() {
  this.bng = null;
  this.bn8 = null;
  this.bn9 = false;
  this.bnh = null;
  this.bni = false;
  this.bnl = null;
  this.bne = null;
  this.bnf = false;
  this.bna = null;
  this.bnb = false;
  this.bnc = null;
  this.bnd = false;
  this.bnj = false;
  this.bnk = false;
  this.bng = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bnl = "ListAccountsPage";
}
export { $c_Lpresto_PrestoRouter$$anon$70 as $c_Lpresto_PrestoRouter$$anon$70 };
$p = $c_Lpresto_PrestoRouter$$anon$70.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$70;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$70() {
}
export { $h_Lpresto_PrestoRouter$$anon$70 as $h_Lpresto_PrestoRouter$$anon$70 };
$h_Lpresto_PrestoRouter$$anon$70.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bng;
});
$p.M = (function() {
  if ((!this.bn9)) {
    this.bn8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bn9 = true;
  }
  return this.bn8;
});
$p.O = (function() {
  if ((!this.bni)) {
    this.bnh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bni = true;
  }
  return this.bnh;
});
$p.D = (function() {
  return this.bnl;
});
$p.t = (function() {
  if ((!this.bnf)) {
    this.bne = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnf = true;
  }
  return this.bne;
});
$p.N = (function() {
  if ((!this.bnb)) {
    this.bna = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnb = true;
  }
  return this.bna;
});
$p.Q = (function() {
  if ((!this.bnd)) {
    this.bnc = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002471.$c_Lpresto_PrestoRouter$$anon$71();
    this.bnd = true;
  }
  return this.bnc;
});
$p.v = (function() {
  if ((!this.bnk)) {
    this.bnj = false;
    this.bnk = true;
  }
  return this.bnj;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee494) => ((p) => \u03b4scrutinee494))($j_presto$002e$002dList$002dAccounts$002dPage$0024.$m_Lpresto_ListAccountsPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$70 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$70, "presto.PrestoRouter$$anon$70", ({
  OM: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$70 as $d_Lpresto_PrestoRouter$$anon$70 };
//# sourceMappingURL=presto.-Presto-Router$$anon$70.js.map
